import databus, { Origins } from '@ykz/ykz-http/core';
import { updateUrlParam, toast, showLoading } from '@ykz/ykz-util/base';
import { copy, getQiNiuLazyImg, checkCopyUsable } from '@ykz/ykz-util/platform';
export default {
  name: 'extension',
  props: {
    inPreview: {
      default: true
    },
    shopName: {
      default: ''
    }
  },
  data: function data() {
    return {
      extensionDialog: {
        show: false,
        showContent: false
      },
      posterDialog: {
        show: false,
        showContent: false
      },
      posterUrl: ''
    };
  },
  methods: {
    goPreview: function goPreview() {
      window.location.href = updateUrlParam(window.location.href, 'inPreview', 1);
    },
    //展示底部弹窗
    showExtensionDialog: function showExtensionDialog() {
      var that = this;
      this.extensionDialog.show = true;
      this.extensionDialog.hasShow = true;
      setTimeout(function () {
        that.extensionDialog.showContent = true;
      }, 100);
    },
    closeExtensionDialog: function closeExtensionDialog() {
      var that = this;
      that.extensionDialog.showContent = false;
      setTimeout(function () {
        that.extensionDialog.show = false;
      }, 200);
    },
    showPosterDialog: function showPosterDialog() {
      var that = this;
      this.posterDialog.show = true;
      this.posterDialog.hasShow = true;
      setTimeout(function () {
        that.posterDialog.showContent = true;
      }, 100);
    },
    closePosterDialog: function closePosterDialog() {
      var that = this;
      that.posterDialog.showContent = false;
      setTimeout(function () {
        that.posterDialog.show = false;
      }, 200);
    },
    //获取海报图
    getPoster: function getPoster() {
      var that = this;
      if (that.posterUrl) {
        that.showPosterDialog();
      } else {
        databus({
          url: '/apiv2/marketing/getPoster',
          data: {
            shareTitle: that.shopName,
            url: updateUrlParam(window.location.href, 'inPreview', ''),
            type: 9
          },
          success: function success(data) {
            console.log(data);
            if (data.code === 1000 && data.bcode === 100) {
              if (data.content && data.content.posterImg) {
                that.posterUrl = data.content.posterImg;
                that.showPosterDialog();
              } else {
                toast('海报图加载失败，请刷新页面重试');
              }
            } else {
              toast(data.message);
            }
          },
          error: function error() {
            toast('网络有误，请刷新重试');
          },
          beforeSend: function beforeSend() {
            showLoading();
          },
          complete: function complete() {
            hideLoading();
          }
        });
      }
    },
    // 复制链接
    copyLink: function copyLink() {
      if (checkCopyUsable(10)) {
        copy(window.location.href).success(function () {
          toast('已复制店铺链接');
        }).fail(function () {
          toast('店铺链接复制失败，请重试！');
        });
      }
    },
    getLazyImg: function getLazyImg(img, stage) {
      return getQiNiuLazyImg(img, stage);
    }
  }
};